import React from 'react';

export type EmailLinkProps = {
    className?: string;
    value: string;
    renderText?: (value: string) => React.ReactNode;
};

const EmailLink: React.FC<EmailLinkProps> = props => {
    const { className, value, renderText } = props;

    return (
        <a className={className} href={`mailto:${value}`}>
            {typeof renderText === 'function' ? renderText(value) : value}
        </a>
    )
};

export default EmailLink;